module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-items-button-icon-08a11b588617ef8bb92985b9f9a122bd.svg";